<span *ngFor="let token of styledText">
  <span [ngSwitch]="token.textPosition">
    <span class="standard" *ngSwitchCase="TextPosition.STANDARD">{{token.text}}</span>
    <sup *ngSwitchCase="TextPosition.SUPER">{{token.text}}</sup>
    <sub *ngSwitchCase="TextPosition.SUB">{{token.text}}</sub>
  </span>
</span>
